import React from 'react'
import PropTypes from 'prop-types'
import { Grid } from '@material-ui/core'
import dayjs from 'dayjs'
import Card from '../../../molecules/Card'
import InfoRow from './InfoRow'

function ScheduleConfiguration ({ schedule }) {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <Card>
          <InfoRow label='Code'><code>{schedule.code}</code></InfoRow>
          <InfoRow label='Expression'><code>{schedule.expression}</code></InfoRow>
          <InfoRow label='Timezone'>{schedule.timezone}</InfoRow>
          <InfoRow label='Target'>{schedule.targetCode}</InfoRow>
          <InfoRow label='Target Type'>{schedule.targetType}</InfoRow>
          <InfoRow label='Retry Policy'>{schedule.retryPolicyName}</InfoRow>
          <InfoRow label='Created'>{dayjs(schedule.createdDate).format('MMM D, YYYY h:mm A')}</InfoRow>
          {schedule.modifiedDate && (
            <InfoRow label='Modified'>{dayjs(schedule.modifiedDate).format('MMM D, YYYY h:mm A')}</InfoRow>
          )}
        </Card>
      </Grid>

      <Grid item xs={12} md={6}>
        <Card>
          <InfoRow label='Description'>{schedule.description || '\u2014'}</InfoRow>
          <InfoRow label='Start Date'>{schedule.startDate ? dayjs(schedule.startDate).format('MMM D, YYYY') : '\u2014'}</InfoRow>
          <InfoRow label='End Date'>{schedule.endDate ? dayjs(schedule.endDate).format('MMM D, YYYY') : '\u2014'}</InfoRow>
          <InfoRow label='Action After Completion'>{schedule.actionAfterCompletion || 'NONE'}</InfoRow>
          <InfoRow label='Run As (Delegated Identity)'>{schedule.delegatedIdentityDisplayName || schedule.delegatedIdentityCode || 'None (system)'}</InfoRow>
          <InfoRow label='Capture Response'>{schedule.captureResponse ? 'Enabled' : 'Disabled'}</InfoRow>
          <InfoRow label='Input'>
            <pre style={{ margin: 0, fontSize: '0.8rem', whiteSpace: 'pre-wrap' }}>
              {JSON.stringify(schedule.input, null, 2)}
            </pre>
          </InfoRow>
        </Card>
      </Grid>
    </Grid>
  )
}

ScheduleConfiguration.propTypes = {
  schedule: PropTypes.object.isRequired
}

export default ScheduleConfiguration
